import classNames from 'classnames';
import { TinySpinner } from 'components/shared/TinySpinner/TinySpinner';
import type { IntlKey } from 'locales';
import { FC } from 'react';
import { useIntl } from 'react-intl';

interface DumpButtonProps {
  e2e: string;
  onClick: () => void;
  isDownloading: boolean;
  className?: string;
  labelKey: IntlKey;
}

export const DumpButton: FC<DumpButtonProps> = ({ e2e, onClick, isDownloading, labelKey, className }) => {
  const { formatMessage } = useIntl();
  return (
    <button onClick={onClick} className={classNames('btn btn-lg', className)} data-e2e={e2e} disabled={isDownloading}>
      {formatMessage({ id: labelKey })}
      {isDownloading && <TinySpinner className="float-end mx-2" />}
    </button>
  );
};
